<template>
  <span>
    <a href="javascript:;" class="text-primary mr-3" @click="openPreview">
      <i class="bx bx-shuffle"></i>
      {{ $t("purpose.classification.action") }}
    </a>

    <b-modal :id="modalId" size="lg" centered :title="$t('purpose.classification.action')" hide-footer>
      <content-loading v-if="loading" />

      <div v-else-if="summary">
        <p class="text-muted">{{ $t("purpose.classification.explanation") }}</p>

        <table class="table table-sm table-bordered">
          <tbody>
            <tr v-for="row in rows" :key="row.key" :class="row.changes ? '' : 'text-muted'">
              <td style="width: 45%">{{ $t(row.label) }}</td>
              <td style="width: 10%" class="text-right">
                <b>{{ row.bucket.count }}</b>
              </td>
              <td>
                <small>{{ row.bucket.samples.join(", ") }}</small>
              </td>
            </tr>
          </tbody>
        </table>

        <p v-if="summary.willChange === 0" class="text-warning">{{ $t("purpose.classification.nothing-to-change") }}</p>
        <p v-else>{{ $t("purpose.classification.confirm", { count: summary.willChange }) }}</p>

        <sweet-button @click="apply" :loading="applying" :disabled="applying || summary.willChange === 0" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mr-2">
          {{ $t("purpose.classification.apply") }}
        </sweet-button>

        <sweet-button @click="undo" :loading="applying" :disabled="applying" variant="warning" icon="mdi mdi-undo" size="sm">
          {{ $t("purpose.classification.undo") }}
        </sweet-button>
      </div>
    </b-modal>
  </span>
</template>

<script>
/**
 * TKP-78 — kullanıma göre toplu sınıflandırma. Önce ÖNİZLEME gösterilir (hiçbir kayıt değişmez); kullanıcı onaylarsa
 * uygulanır. "Geri al" son koşumu iptal eder. İki tarafta da kullanılan ve hiç kullanılmayan amaçlara dokunulmaz.
 */
export default {
  props: {
    state: { type: String, required: true },
  },
  data() {
    return { summary: undefined, loading: false, applying: false };
  },
  computed: {
    modalId() {
      return `purpose-classification-${this.state}`;
    },
    rows() {
      if (!this.summary) return [];
      return [
        { key: "toProcessing", label: "purpose.classification.to-processing", bucket: this.summary.toProcessing, changes: true },
        { key: "toTransfering", label: "purpose.classification.to-transfering", bucket: this.summary.toTransfering, changes: true },
        { key: "skippedBothSides", label: "purpose.classification.skipped-both", bucket: this.summary.skippedBothSides, changes: false },
        { key: "skippedUnused", label: "purpose.classification.skipped-unused", bucket: this.summary.skippedUnused, changes: false },
        { key: "skippedAlreadyClassified", label: "purpose.classification.skipped-classified", bucket: this.summary.skippedAlreadyClassified, changes: false },
      ];
    },
  },
  methods: {
    async openPreview() {
      this.summary = undefined;
      this.loading = true;
      this.$root.$emit("bv::show::modal", this.modalId);
      try {
        const { data } = await this.$store.dispatch(`${this.state}/classificationPreview`);
        this.summary = data;
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.loading = false;
      }
    },

    async apply() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) return;

      this.applying = true;
      try {
        const { data } = await this.$store.dispatch(`${this.state}/classificationApply`);
        this.$toast.success(this.$t("purpose.classification.applied", { count: data.changed }));
        this.$root.$emit("bv::hide::modal", this.modalId);
        this.$emit("done");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.applying = false;
      }
    },

    async undo() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) return;

      this.applying = true;
      try {
        const { data } = await this.$store.dispatch(`${this.state}/classificationUndo`);
        if (data.nothingToUndo) {
          this.$toast.info(this.$t("purpose.classification.nothing-to-undo"));
        } else {
          this.$toast.success(this.$t("purpose.classification.undone", { count: data.reverted }));
        }
        this.$root.$emit("bv::hide::modal", this.modalId);
        this.$emit("done");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.applying = false;
      }
    },
  },
};
</script>
